import { Flex, Image, Menu, Text } from 'components'
import { ActivityMoment } from 'types'
import { useEvent } from '../../../utils/eventUtils'
import { activityMomentOptions } from '../../../utils/momentUtils'
import TemplateOverrides from './TemplateOverrides'

interface Props {
  value: ActivityMoment
  onChange: (moment: ActivityMoment) => void
}

export default function ManageActivityMoment({ value, onChange }: Props) {
  const { event } = useEvent()

  if (!event) return null

  function handleChange(body: Partial<ActivityMoment>) {
    onChange({ ...value, ...body })
  }

  const { template } = value

  return (
    <Flex direction="column" gap={2}>
      <Menu
        label="Type"
        onChange={activityType => handleChange({ activityType })}
        options={activityTypes.map(t => {
          const { iconSrc, label } = activityMomentOptions.find(m => m.type === t) || {}
          return {
            value: t,
            label: (
              <Flex align="center" gap={2}>
                <Image src={iconSrc} />
                <Text>{label}</Text>
              </Flex>
            ),
          }
        })}
        value={value.activityType}
        variant="outline"
      />

      <TemplateOverrides
        partialTemplate={template}
        onUpdate={v => handleChange({ template: { ...template, ...v } })}
      />
    </Flex>
  )
}

const activityTypes: ActivityMoment['activityType'][] = ['count', 'timed']
